import { GET_EVENT, UPDATE_EVENT, UPDATE_EVENT_PHOTO } from 'actions/Types';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';
import { eventChanged } from './utils';

const defaultState = null;

export default (state = defaultState, action) => {
  //If we have a match on the event or user dash, we should clear the existing event
  //before loading the next
  if (action.type === '@@router/LOCATION_CHANGE') {
    if (!state) return state;
    const pathName = action.payload.location.pathname;

    const userMatch = matchPath(pathName, {
      path: Paths.UserDash
    });

    if (userMatch) {
      return null;
    }

    if (eventChanged(pathName, state)) {
      return null;
    }
  }

  if (action.type === `${GET_EVENT}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_EVENT}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${UPDATE_EVENT_PHOTO}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
